const ucaEnv = function UCAEnvironment(banner, env, platform) {
  const baseHeader = {
    dev: {
      "x-swy-client-id": platform === "web" ? "web-portal" : "mobile",
      "X-SWY_BANNER": banner,
      "Ocp-Apim-Subscription-Key": "4132817565e4404bbef09f46711fb9a0",
    },
    dev2: {
      "x-swy-client-id": platform === "web" ? "web-portal" : "mobile",
      "X-SWY_BANNER": banner,
      "Ocp-Apim-Subscription-Key": "cfd7193b15df4931900fb556087243b8",
    },
    qa: {
      "x-swy-client-id": platform === "web" ? "web-portal" : "mobile",
      "X-SWY_BANNER": banner,
      "Ocp-Apim-Subscription-Key": "0c7a816ba9f445d59e84f81c0534a570",
    },
    acceptance: {
      "x-swy-client-id": platform === "web" ? "web-portal" : "mobile",
      "X-SWY_BANNER": banner,
      "Ocp-Apim-Subscription-Key": "42928f5ef28240649b3656d26478526f",
    },
    perf: {
      "x-swy-client-id": platform === "web" ? "web-portal" : "mobile",
      "X-SWY_BANNER": banner,
      "Ocp-Apim-Subscription-Key": "289b8c38dfd8493494399e5e31914504",
    },
    stage: {
      "x-swy-client-id": platform === "web" ? "web-portal" : "mobile",
      "X-SWY_BANNER": banner,
      "Ocp-Apim-Subscription-Key": "d95f31d5355c4d47bb52f888e189a6ed ",
    },
    prod: {
      "x-swy-client-id": platform === "web" ? "web-portal" : "mobile",
      "X-SWY_BANNER": banner,
      "Ocp-Apim-Subscription-Key": "891be886acd245258394a4016940c883",
    },
  };

  const bannerConfiguration = {
    tomthumb: {
      banner: "Tom Thumb",
      loyaltyPgmName: "Reward Card",
      promoDescription: "Reward Card Price",
      estimatedSavings: "Est. Reward Card Savings",
      logoUrls: {
        color: "TomThumb_RGB.svg",
        white: "TomThumb_W.svg",
      },
    },
    albertsons: {
      banner: "Albertsons",
      loyaltyPgmName: "On Sale",
      promoDescription: "On Sale Now",
      estimatedSavings: "Est. On Sale Savings",
      logoUrls: {
        color: "Albertsons_RGB.svg",
        white: "Albertsons_W.svg",
      },
    },
    vons: {
      banner: "Vons",
      loyaltyPgmName: "Club Card",
      promoDescription: "Club Card Price",
      estimatedSavings: "Est. Club Card Savings",
      logoUrls: {
        color: "Vons_RGB.svg",
        white: "Vons_W.svg",
      },
    },
    safeway: {
      banner: "Safeway",
      loyaltyPgmName: "Club Card",
      promoDescription: "Club Card Price",
      estimatedSavings: "Est. Club Card Savings",
      logoUrls: {
        color: "Safeway_RGB.svg",
        white: "Safeway_W.svg",
      },
    },
    randalls: {
      banner: "Randalls",
      loyaltyPgmName: "Remarkable Card",
      promoDescription: "Remarkable Card Price",
      estimatedSavings: "Est. Remarkable Card Savings",
      logoUrls: {
        color: "Randalls_RGB.svg",
        white: "Randalls_W.svg",
      },
    },
    pavilions: {
      banner: "Pavilions",
      loyaltyPgmName: "Club Price",
      promoDescription: "Club Price",
      estimatedSavings: "Est. Club Price Savings",
      logoUrls: {
        color: "Pavilions_RGB.svg",
        white: "Pavilions_W.svg",
      },
    },
    jewelosco: {
      banner: "Jewel-Osco",
      loyaltyPgmName: "Sale Price",
      promoDescription: "Sale Price",
      estimatedSavings: "Est. Sale Price Savings",
      logoUrls: {
        color: "JewelOsco_Vert_Oval_RGB.svg",
        white: "JewelOsco_Vert_Oval_W.svg",
      },
    },
    carrsqc: {
      banner: "Carrs",
      loyaltyPgmName: "Club Card",
      promoDescription: "Club Card Price",
      estimatedSavings: "Est. Club Card Savings",
      logoUrls: {
        color: "Carrs_RGB.svg",
        white: "Carrs_W.svg",
      },
    },
    acmemarkets: {
      banner: "Acme Markets",
      loyaltyPgmName: "Club Card",
      promoDescription: "Club Card Price",
      estimatedSavings: "Est. Club Card Savings",
      logoUrls: {
        color: "Acme_RGB.svg",
        white: "Acme_W.svg",
      },
    },
    shaws: {
      banner: "Shaws",
      loyaltyPgmName: "Club Card",
      promoDescription: "Club Card Price",
      estimatedSavings: "Est. Club Card Savings",
      logoUrls: {
        color: "Shaws_RGB.svg",
        white: "Shaws_W.svg",
      },
    },
    starmarket: {
      banner: "Starmarket",
      loyaltyPgmName: "Club Card",
      promoDescription: "Club Card Price",
      estimatedSavings: "Est. Club Card Savings",
      logoUrls: {
        color: "StarMarket_RGB.svg",
        white: "StarMarket_W.svg",
      },
    },
    shopamigos: {
      banner: "Shopamigos",
      loyaltyPgmName: "Club Card",
      promoDescription: "Club Card Price",
      estimatedSavings: "Est. Club Card Savings",
      logoUrls: {
        color: "ShopAmigos_RGB.svg",
        white: "ShopAmigos_W.svg",
      },
    },
    shopunitedsupermarkets: {
      banner: "Shop United Supermarkets",
      loyaltyPgmName: "Club Card",
      promoDescription: "Club Card Price",
      estimatedSavings: "Est. Club Card Savings",
      logoUrls: {
        color: "ShopUnitedSupermarkets_RGB.svg",
        white: "ShopUnitedSupermarkets_W.svg",
      },
    },
    shopmarketstreet: {
      banner: "Shop Market Street",
      loyaltyPgmName: "Club Card",
      promoDescription: "Club Card Price",
      estimatedSavings: "Est. Club Card Savings",
      logoUrls: {
        color: "ShopMarketStreet_RGB.svg",
        white: "ShopMarketStreet_W.svg",
      },
    },
    shopalbertsonsmarket: {
      banner: "Shop Albertsons Market",
      loyaltyPgmName: "Club Card", 
      promoDescription: "Club Card Price",
      estimatedSavings: "Est. Club Card Savings",
      logoUrls: {  
        color: "ShopAlbertsonsMarket_RGB.svg",
        white: "ShopAlbertsonsMarket_W.svg",
      },  
    },
  };
  const envObj = {
    dev: {
      LEFT_NAV_API: `https://www-dev1.${banner}.com/bin/safeway/ucanavigation?banner=${banner}`,
      UCA_BASE_API: `https://www-dev1.${banner}.com/abs/acceptancepub/cnc/ucaservice/api/uca/customers/`,
      API_HEADERS_GET_V1: {
        ...baseHeader[env],
        Accept: "application/vnd.safeway.v1+json",
      },
      API_HEADERS_GET_V2: {
        ...baseHeader[env],
        Accept: "application/vnd.safeway.v2+json",
      },
      API_HEADERS_PATCH_V1: {
        ...baseHeader[env],
        "Content-Type": "application/vnd.safeway.v1.merge-patch+json",
        Accept: "application/vnd.safeway.v1+json",
      },
      AUTH_API: `https://www-dev1.${banner}.com/bin/safeway/unified/userinfo?banner=${banner}`,
      SSO_URL: `https://www-dev1.${banner}.com/bin/safeway/sso`,
      SIGN_IN_URL: `https://www-dev1.${banner}.com/account/sign-in.html`,
      RE_SIGN_IN_URL: `https://www-dev1.${banner}.com/account/re-sign-in.html`,
      BANNER_URL: `https://www-dev1`,
      CHECK_USER_ACTIVE_SESSION: true,
      BANNER_CONFIGURATION: bannerConfiguration[banner],
      imageBaseUrl: "https://www-qa2.randalls.com",
      REWARDS_PAGE_BASE_API: `https://www-dev1.${banner}.com/abs/qapub/svcp/xapi/api/v1`,
      REWARDS_PAGE_APIM_SUBSCRIPTION_KEY: "71f59cd81b5c4b7f805320328326394e",
    },
    dev2: {
      LEFT_NAV_API: `https://www-dev2.${banner}.com/bin/safeway/ucanavigation?banner=${banner}`,
      UCA_BASE_API: `https://www-dev2.${banner}.com/abs/acceptancepub/cnc/ucaservice/api/uca/customers/`,
      API_HEADERS_GET_V1: {
        ...baseHeader[env],
        Accept: "application/vnd.safeway.v1+json",
      },
      API_HEADERS_GET_V2: {
        ...baseHeader[env],
        Accept: "application/vnd.safeway.v2+json",
      },
      API_HEADERS_PATCH_V1: {
        ...baseHeader[env],
        "Content-Type": "application/vnd.safeway.v1.merge-patch+json",
        Accept: "application/vnd.safeway.v1+json",
      },
      AUTH_API: `https://www-dev2.${banner}.com/bin/safeway/unified/userinfo?banner=${banner}`,
      SSO_URL: `https://www-dev2.${banner}.com/bin/safeway/sso`,
      SIGN_IN_URL: `https://www-dev2.${banner}.com/account/sign-in.html`,
      RE_SIGN_IN_URL: `https://www-dev2.${banner}.com/account/re-sign-in.html`,
      BANNER_URL: `https://www-dev2`,
      CHECK_USER_ACTIVE_SESSION: false,
      BANNER_CONFIGURATION: bannerConfiguration[banner],
      imageBaseUrl: "https://www-qa2.randalls.com",
      REWARDS_PAGE_BASE_API: `https://www-dev2.${banner}.com/abs/qapub/svcp/xapi/api/v1`,
      REWARDS_PAGE_APIM_SUBSCRIPTION_KEY: "42928f5ef28240649b3656d26478526f",
    },
    qa: {
      LEFT_NAV_API: `https://www-qa1.${banner}.com/bin/safeway/ucanavigation?banner=${banner}`,
      UCA_BASE_API: `https://www-qa1.${banner}.com/abs/qapub/cnc/ucaservice/api/uca/customers/`,
      API_HEADERS_GET_V1: {
        ...baseHeader[env],
        Accept: "application/vnd.safeway.v1+json",
      },
      API_HEADERS_GET_V2: {
        ...baseHeader[env],
        Accept: "application/vnd.safeway.v2+json",
      },
      API_HEADERS_PATCH_V1: {
        ...baseHeader[env],
        "Content-Type": "application/vnd.safeway.v1.merge-patch+json",
        Accept: "application/vnd.safeway.v1+json",
      },
      AUTH_API: `https://www-qa1.${banner}.com/bin/safeway/unified/userinfo?banner=${banner}`,
      SSO_URL: `https://www-qa1.${banner}.com/bin/safeway/sso`,
      SIGN_IN_URL: `https://www-qa1.${banner}.com/account/sign-in.html`,
      RE_SIGN_IN_URL: `https://www-qa1.${banner}.com/account/re-sign-in.html`,
      BANNER_URL: `https://www-qa1`,
      CHECK_USER_ACTIVE_SESSION: true,
      BANNER_CONFIGURATION: bannerConfiguration[banner],
      imageBaseUrl: "",
      REWARDS_PAGE_BASE_API: `https://www-qa1.${banner}.com/abs/qapub/svcp/xapi/api/v1`,
      REWARDS_PAGE_APIM_SUBSCRIPTION_KEY: "d1c5ae45dd9e4f3c8ba3fdedb31d641f",
    },
    acceptance: {
      LEFT_NAV_API: `https://www-qa2.${banner}.com/bin/safeway/ucanavigation?banner=${banner}`,
      UCA_BASE_API: `https://www-qa2.${banner}.com/abs/acceptancepub/cnc/ucaservice/api/uca/customers/`,
      API_HEADERS_GET_V1: {
        ...baseHeader[env],
        Accept: "application/vnd.safeway.v1+json",
      },
      API_HEADERS_GET_V2: {
        ...baseHeader[env],
        Accept: "application/vnd.safeway.v2+json",
      },
      API_HEADERS_PATCH_V1: {
        ...baseHeader[env],
        "Content-Type": "application/vnd.safeway.v1.merge-patch+json",
        Accept: "application/vnd.safeway.v1+json",
      },
      AUTH_API: `https://www-qa2.${banner}.com/bin/safeway/unified/userinfo?banner=${banner}`,
      SSO_URL: `https://www-qa2.${banner}.com/bin/safeway/sso`,
      SIGN_IN_URL: `https://www-qa2.${banner}.com/account/sign-in.html`,
      RE_SIGN_IN_URL: `https://www-qa2.${banner}.com/account/re-sign-in.html`,
      BANNER_URL: `https://www-qa2`,
      CHECK_USER_ACTIVE_SESSION: true,
      BANNER_CONFIGURATION: bannerConfiguration[banner],
      imageBaseUrl: "",
      REWARDS_PAGE_BASE_API: `https://www-qa2.${banner}.com/abs/acceptancepub/svcp/xapi/api/v1`,
      REWARDS_PAGE_APIM_SUBSCRIPTION_KEY: "3f9ba409c3274105b469bc18d9d5373b",
    },
    perf: {
      LEFT_NAV_API: `https://www-qa3.${banner}.com/bin/safeway/ucanavigation?banner=${banner}`,
      UCA_BASE_API: `https://www-qa3.${banner}.com/abs/perfpub/cnc/ucaservice/api/uca/customers/`,
      API_HEADERS_GET_V1: {
        ...baseHeader[env],
        Accept: "application/vnd.safeway.v1+json",
      },
      API_HEADERS_GET_V2: {
        ...baseHeader[env],
        Accept: "application/vnd.safeway.v2+json",
      },
      API_HEADERS_PATCH_V1: {
        ...baseHeader[env],
        "Content-Type": "application/vnd.safeway.v1.merge-patch+json",
        Accept: "application/vnd.safeway.v1+json",
      },
      AUTH_API: `https://www-qa3.${banner}.com/bin/safeway/unified/userinfo?banner=${banner}`,
      SSO_URL: `https://www-qa3.${banner}.com/bin/safeway/sso`,
      SIGN_IN_URL: `https://www-qa3.${banner}.com/account/sign-in.html`,
      RE_SIGN_IN_URL: `https://www-qa3.${banner}.com/account/re-sign-in.html`,
      BANNER_URL: `https://www-qa3`,
      CHECK_USER_ACTIVE_SESSION: true,
      BANNER_CONFIGURATION: bannerConfiguration[banner],
      imageBaseUrl: "",
      REWARDS_PAGE_BASE_API: `https://www-qa3.${banner}.com/abs/perfpub/svcp/xapi/api/v1`,
      REWARDS_PAGE_APIM_SUBSCRIPTION_KEY: "2d8a7f72243d41a1ae15f9f01fd55f7c",
    },
    stage: {
      LEFT_NAV_API: `https://www-stage.${banner}.com/bin/safeway/ucanavigation?banner=${banner}`,
      UCA_BASE_API: `https://www-stage.${banner}.com/abs/stgpub/cnc/ucaservice/api/uca/customers/`,
      API_HEADERS_GET_V1: {
        ...baseHeader[env],
        Accept: "application/vnd.safeway.v1+json",
      },
      API_HEADERS_GET_V2: {
        ...baseHeader[env],
        Accept: "application/vnd.safeway.v2+json",
      },
      API_HEADERS_PATCH_V1: {
        ...baseHeader[env],
        "Content-Type": "application/vnd.safeway.v1.merge-patch+json",
        Accept: "application/vnd.safeway.v1+json",
      },
      AUTH_API: `https://www-stage.${banner}.com/bin/safeway/unified/userinfo?banner=${banner}`,
      SSO_URL: `https://www-stage.${banner}.com/bin/safeway/sso`,
      SIGN_IN_URL: `https://www-stage.${banner}.com/account/sign-in.html`,
      RE_SIGN_IN_URL: `https://www-stage.${banner}.com/account/re-sign-in.html`,
      BANNER_URL: `https://www-stage`,
      CHECK_USER_ACTIVE_SESSION: true,
      BANNER_CONFIGURATION: bannerConfiguration[banner],
      imageBaseUrl: "",
      REWARDS_PAGE_BASE_API: `https://www-stage.${banner}.com/abs/stgpub/svcp/xapi/api/v1`,
      REWARDS_PAGE_APIM_SUBSCRIPTION_KEY: "77c19c338a34451880d1f3f7aa3650bc",
    },
    prod: {
      LEFT_NAV_API: `https://www.${banner}.com/bin/safeway/ucanavigation?banner=${banner}`,
      UCA_BASE_API: `https://www.${banner}.com/abs/pub/cnc/ucaservice/api/uca/customers/`,
      API_HEADERS_GET_V1: {
        ...baseHeader[env],
        Accept: "application/vnd.safeway.v1+json",
      },
      API_HEADERS_GET_V2: {
        ...baseHeader[env],
        Accept: "application/vnd.safeway.v2+json",
      },
      API_HEADERS_PATCH_V1: {
        ...baseHeader[env],
        "Content-Type": "application/vnd.safeway.v1.merge-patch+json",
        Accept: "application/vnd.safeway.v1+json",
      },
      AUTH_API: `https://www.${banner}.com/bin/safeway/unified/userinfo?banner=${banner}`,
      SSO_URL: `https://www.${banner}.com/bin/safeway/sso`,
      SIGN_IN_URL: `https://www.${banner}.com/account/sign-in.html`,
      RE_SIGN_IN_URL: `https://www.${banner}.com/account/re-sign-in.html`,
      BANNER_URL: `https://www`,
      CHECK_USER_ACTIVE_SESSION: true,
      BANNER_CONFIGURATION: bannerConfiguration[banner],
      imageBaseUrl: "",
      REWARDS_PAGE_BASE_API: `https://www.${banner}.com/abs/pub/svcp/xapi/api/v1`,
      REWARDS_PAGE_APIM_SUBSCRIPTION_KEY: "1cc6510d28594a86981839c61f9afea0",
    },
  };
  return envObj[env];
};

export default ucaEnv;
